<template lang="pug">
.search
    v-input(size="normal", :value="defaultValue" v-bind:placeholder="placeholder" v-model="keyword")
    .btn.btn-primary.btn-small(@click="doSearch") 搜索
</template>
<script>
export default {
    props: {
      placeholder: String,
      defaultValue: String
    },
    data(){
        return {
            keyword: ""
        }
    },
    watch: {
      defaultValue: function(val, oldVal) {
        this.defaultValue = val
        this.keyword = this.defaultValue
      }
    },
    methods: {
        doSearch(){
            this.$emit("doSearch", this.keyword) 
        }
    }
}
</script>
<style >
.search {
    display: inline-block;
    height: 28px;
    line-height: 28px;
}
.btn {
    display: inline-block;
}
.input-wrap {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// search.vue?62afdbc6